<template>
  <nk-page commercialAccess="System">
    <div class="h-100 d-flex flex-column overflow-auto">
      <div class="form-container h-100">
        <div class="container-fluid h-100">
          <div class="row flex-row-reverse h-100">
            <div class="col-12 flex-1">

              <nk-col-form-group :label="$t('notification.description')" :labelSizes="{ sm: 12 }" :dataSizes="{ sm: 12 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
                <p style="white-space: break-spaces;border-radius: 10px;max-height:100px;" class="mt-3 p-3 bg-white  y-overflow-scroll">{{ data.description }}</p>
              </nk-col-form-group>
              <div v-show="data.part == 'Chat'">
                <nk-col-form-group :labelSizes="{ sm: 12 }" :dataSizes="{ sm: 12 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
                  <nk-textarea :options="responseOptions" :rows="5" v-model="localData.note.value"></nk-textarea>
                </nk-col-form-group>
                <nk-button :options="sendButton" @click="sendButton.handle()"></nk-button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </nk-page>
</template>
<script>
  import _ from 'lodash'
  import { post } from '~/plugins/nikan-api'
  import Endpoints from '@nikan/endpoints'
  import AccessControl from '~/views/operation-roles/access-control'
  import validators, { isEmpty } from "@/statics/validators"
  import $sc from "@/plugins/shortcut.collection"
  import { mapActions, mapGetters } from "vuex"

  export default {
    modal: {
      size: 'SM',
      stateUID: 'show_description_123',
    },
    components: {
    },
    props: {
      data: { type: Object },
      options: { type: Object },
    },
    data() {
      return {
        validators: {
          text: validators('required'),
        },
        localData: {
          note: {
            value: null,
            required: true,
            name: 'متن'
          },

        },
        sendButton: {
          title: this.$t('notification.send-response'),
          shortcut: $sc.find('save'),
          isPrimary: false,
          handle: () => {
            console.log('handler')
            this.sendNotification(this, this.userDetail.id,)
          },
          icon: 'fa-solid fa-paper-plane-top',
          // policyClaims: { or: ['Product_Product_Edit', 'Product_Product_Add'] },
        },
        responseOptions: {
          placeholder: this.$t('notification.make-answer')
        },

        modifyData: '---',
        settings: {
          entityType: '',
          entityId: '',
        }

      }
    },
    computed: {
      ...mapGetters({
        userDetail: 'appContext/getUser'
      })
    },
    mounted() {
      this.settings = _.extend({}, this.settings, this.options)
      this.settings.receiverUser = { id: this.data.senderUserId }

      // this.prepareWindow(this.$t(`notification.description`))

    },
    created() {

    },
    methods: {
      ...mapActions({
        sendNotification: 'notifications/sendNotification'
      })
    },
  }
</script>
<style></style>
